import { axiosInstance } from "@/axios/interceptors";
import { ZodSentryReporter } from "@/lib/zod-sentry-reporter";
import { z } from "zod";

export type SendPhone2FAPayload = {
	phone_number: string;
	global_country_id: number;
};

const IsoDateTime = z.string().datetime();
const LocalDateTime = z.string().regex(/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/);

export const SendPhone2FAResponseSchema = z.object({
	message: z.string(),
	expire_at: IsoDateTime,
	expire_at_local: z.union([IsoDateTime, LocalDateTime]),
});
export type SendPhone2FAResponse = z.infer<typeof SendPhone2FAResponseSchema>;

export async function sendPhone2FA(payload: SendPhone2FAPayload) {
	const response = await axiosInstance.post("/guests/send-2fa", {
		...payload,
	});
	return ZodSentryReporter.parse(SendPhone2FAResponseSchema, response);
}

export type VerifyPhone2FAPayload = {
	phone_number: string;
	global_country_id: number;
	verification_code: string;
	phone_fallback?: {
		biometric_sync_id: number;
		candidate_ids: number[];
	};
};

export const AuthTokenResponseSchema = z.object({
	access_token: z.string(),
	token_type: z.literal("Bearer"),
	expires_in: z.number(),
	purpose: z.string().nullable().optional(),
});
export type PhoneAuthTokenResponse = z.infer<typeof AuthTokenResponseSchema>;

export async function verifyPhone2FA(payload: VerifyPhone2FAPayload) {
	const response = await axiosInstance.post("/guests/verify-2fa", {
		...payload,
	});
	return ZodSentryReporter.parse(AuthTokenResponseSchema, response);
}
